import React from 'react';
import PropTypes from 'prop-types';
import { DarkText, DarkButton, Icon } from '@lyearn-team/frontend-components';
import { Link } from 'react-router-dom';

import * as s from './style';

class Header extends React.PureComponent {
  render() {
    const { title, link, height } = this.props;
    const isMobile = window.innerWidth < 768;
    return (
      <div className={s.headerRoot(isMobile, height)}>
        <Link to={link} className="link">
          <DarkButton.IconButton>
            <Icon type="arrow-left" />
          </DarkButton.IconButton>
        </Link>
        <DarkText
          color="copper"
          letterSpacing={2}
          lineHeight={1.71}
          fontSize={14}
          fontSizeM={12}
          className="headerText"
        >
          {title}
        </DarkText>
      </div>
    );
  }
}

Header.propTypes = {
  title: PropTypes.string,
  link: PropTypes.string
};

Header.defaultProps = {
  title: '',
  link: '/'
};

export default Header;
